import Vue from 'vue'
import Router from 'vue-router'
import TokenService from "../services/storage.service";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

//const Charts = () => import('@/views/charts/Charts')
//const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
//const Cards = () => import('@/views/base/Cards')
//const Forms = () => import('@/views/base/Forms')
//const Switches = () => import('@/views/base/Switches')
//const Tables = () => import('@/views/base/Tables')
//const Tabs = () => import('@/views/base/Tabs')
//const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
//const Carousels = () => import('@/views/base/Carousels')
//const Collapses = () => import('@/views/base/Collapses')
//const Jumbotrons = () => import('@/views/base/Jumbotrons')
//const ListGroups = () => import('@/views/base/ListGroups')
//const Navs = () => import('@/views/base/Navs')
//const Navbars = () => import('@/views/base/Navbars')
//const Paginations = () => import('@/views/base/Paginations')
//const Popovers = () => import('@/views/base/Popovers')
//const ProgressBars = () => import('@/views/base/ProgressBars')
//const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
//const StandardButtons = () => import('@/views/buttons/StandardButtons')
//const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
//const Dropdowns = () => import('@/views/buttons/Dropdowns')
//const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
//const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
//const Brands = () => import('@/views/icons/Brands')
//const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
//const Alerts = () => import('@/views/notifications/Alerts')
//const Badges = () => import('@/views/notifications/Badges')
//const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')


//Fashgio
const ProductImport = () => import('@/views/products/Import')
const ProductList = () => import('@/views/products/List')
const UserList = () => import('@/views/users/Customer')
const UserListRole = () => import('@/views/users/UserRoles')
const UserServiceList = () => import('@/views/users/Users')
const UserRoles = () => import('@/views/users/Roles')
const UserEdit = () => import('@/views/users/Edit')
//const ShopNew = () => import('@/views/shops/New')
//const ShopEdit = () => import('@/views/shops/Edit')
//const ShopXml = () => import('@/views/shops/Xml')


Vue.use(Router)

const router =  new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
      {
          path: '/',
          name: 'Login',
          component: Login,
          meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true
          }
      },
      {
      path: '/dashboard',
      name: 'Start',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'products',
          name: 'Produkte',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'import',
              name: 'Import',
              component: ProductImport
            },
            {
              path: 'list',
              name: 'Importierte Produkte',
              component: ProductList
            }
          ]
        },

        {
          path: 'users',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'roles/:role',
              name: 'Benutzer-Liste',
              component: UserListRole
            },
            {
              path: 'list/customer',
              name: 'Benutzer-Liste',
              component: UserList
            },
            {
              path: 'customer/:id',
              name: 'Benutzer editieren',
              component: UserEdit
            },
            {
              path: 'list/service',
              name: 'Dienstleister-Liste',
              component: UserServiceList
            },
            {
              path: 'roles',
              name: 'Rollen',
              component: UserRoles
            }
          ]
        },

        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },

          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
        }
      ]
    },
    {
      path: 'register',
      name: 'Register',
      component: Register,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    }
  ]
}

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const loggedIn = !!TokenService.getToken()
   next()

})


export default router;
